import { jsx as _jsx } from "react/jsx-runtime";
import { StepLabel } from "@mui/material";
import { forwardRef } from "react";
export const UiStepLabel = forwardRef((props, ref) => (_jsx(StepLabel, Object.assign({ ref: ref }, props))));
//# sourceMappingURL=ui_step_label.js.map